module.exports = __webpack_public_path__ + "img/share_packet_bg.5c531961.png";